<form [formGroup]="form">
  <mat-form-field appearance="outline" color="primary">
    <mat-label>{{ 'Country' | translate }}</mat-label>
    <mat-select formControlName="COUNTRY">
      @for (country of countryList; track country) {
        <mat-option [value]="country.code">{{ country?.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</form>
